export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/guardian.08a8e97c.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};